import { Select } from '@nextretreat/ui-components/dist/Select'
import countriesOptions from './data.json'
import { useFormikContext } from 'formik'
import { IVenueFormValues } from 'FormPage/FormPage'

export const CountrySelect = () => {
  const { values, setFieldValue } = useFormikContext<IVenueFormValues>()
  return (
    <Select
      isBlock
      label="Country"
      placeholder="Select country"
      options={countriesOptions}
      onChange={(val) => {
        setFieldValue('generalInfo.country', val.label)
        setFieldValue('generalInfo.countryCode', val.value)
      }}
      value={{
        label: values.generalInfo.country,
        value: values.generalInfo.countryCode,
      }}
    />
  )
}

export default CountrySelect
